import BaseUtil from "../../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const initState = {
    loadingCount: 0,
    unitMember: [],
    applyDrawerPageable: {
        currentPage: 1,
        pageSize: 20,
    },
    pageable: {
        currentPage: 1,
        pageSize: 20,
    },
    removeCheckedUsers: [],
    idAttributeFilter: null,
    unitMemberEditModalVisible: false,
    unitMemberEditModalLoading: false,
    toEditUnitMembers: null,
    isPublished: false,
    isDirty: false,
    unitMemberKw: "",
    deleteRecord: null,
    applyDrawerVisible: false,
    applyDrawerLoading: false,
    applicationList: [],
    applyModalVisible: false,
    fileDetailVisible: false,
    fileDetailUser: null,
    userWorkUnitChangePendingCount: 0,
    workStatusList: [],
    docTeam: [],
    locationList: [],
};

const [
    viewModel,
    update, reset,
] = BaseUtil.getViewModel(initState, type);

export {
    update, reset,
};

export default viewModel;
